// axiosPartnerInterceptor.js
import axios from "axios";

// ============================================
// INTERCEPTOR 1 — Dynamic Token (partner/sso)
// ============================================
const withPartnerInterceptor = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const partnerFlag = localStorage.getItem("partnerFlag");
      const partnerSsoToken = localStorage.getItem("partnerSsoToken");
      const storeToken = localStorage.getItem("ssoToken");

      const token = partnerFlag == "true" ? partnerSsoToken : storeToken;

      const permissions = localStorage.getItem("permissions");

      if (token) config.headers.Authorization = `Bearer ${token}`;
      if (permissions) config.headers.Perm = permissions;

      return config;
    },
    (error) => Promise.reject(error)
  );
};


// ============================================
// INTERCEPTOR 2 — Always SSO Token
// ============================================
const withSsoInterceptor = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("ssoToken");

      const permissions = localStorage.getItem("permissions");

      if (token) config.headers.Authorization = `Bearer ${token}`;
      if (permissions) config.headers.Perm = permissions;

      return config;
    },
    (error) => Promise.reject(error)
  );
};


// ============================================
// INSTANCES — Dynamic Token (partner/sso)
// ============================================

export const axiosPartnerJson = axios.create({
  headers: { "Content-Type": "application/json" },
});
withPartnerInterceptor(axiosPartnerJson);


export const axiosPartnerText = axios.create({
  headers: { "Content-Type": "text/plain" },
});
withPartnerInterceptor(axiosPartnerText);


export const axiosPartnerMultipart = axios.create({
  headers: { "Content-Type": "multipart/form-data" },
});
withPartnerInterceptor(axiosPartnerMultipart);


export const axiosPartnerBlob = axios.create({
  responseType: "blob",
});
withPartnerInterceptor(axiosPartnerBlob);


export const axiosPartnerFormData = axios.create();
withPartnerInterceptor(axiosPartnerFormData);

export const axiosPartnerJsonReserv1 = axios.create({
  headers: { 
    "Content-Type": "application/json",
    reserv: 1
  },
});
withPartnerInterceptor(axiosPartnerJsonReserv1);


// ============================================
// INSTANCES — Always SSO Token
// ============================================

export const axiosSsoJson = axios.create({
  headers: { "Content-Type": "application/json" },
});
withSsoInterceptor(axiosSsoJson);


export const axiosSsoText = axios.create({
  headers: { "Content-Type": "text/plain" },
});
withSsoInterceptor(axiosSsoText);


export const axiosSsoMultipart = axios.create({
  headers: { "Content-Type": "multipart/form-data" },
});
withSsoInterceptor(axiosSsoMultipart);


export const axiosSsoBlob = axios.create({
  responseType: "blob",
});
withSsoInterceptor(axiosSsoBlob);


export const axiosSsoFormData = axios.create();
withSsoInterceptor(axiosSsoFormData);

export const axiosSsoJsonReserv1 = axios.create({
  headers: { 
    "Content-Type": "application/json",
    reserv: 1 
  },
});

withSsoInterceptor(axiosSsoJsonReserv1);


export const axiosSsoJsonReserv0 = axios.create({
  headers: { 
    "Content-Type": "application/json",
    reserv: 0 
  },
});
withSsoInterceptor(axiosSsoJsonReserv0);